__turbopack_context__.v({
  "inline_code": "_2kydya_inline_code",
});
